import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import './SearchBar.css';

const SearchBar = () => {
    const [term, setTerm] = useState('');
    const history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault();
        history.push(`/search?q=${term}`)
    }
    return ( 
        <div className="searchbar">
        <form onSubmit={handleSubmit}>
        <label htmlFor="search">Search:</label>
        <input 
          id="search" 
          type="text" 
          onChange={(e) => setTerm(e.target.value)} 
          required 
        />
      </form>
    </div>
     );
}
 
export default SearchBar;